module.exports = __webpack_public_path__ + "img/irose-test4-step1a.1d08d1f2.png";